import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import _8x71 from "./8x71.png";
import _8x72 from "./8x72.png";
import _8x73 from "./8x73.png";

const width = "70%";
const height = "auto";
const viewBox = "0 0 320 174";


const getDimensions = (size, sizes) => {
  if (
    size &&
    typeof size.width === "number" &&
    typeof size.height === "number"
  ) {
    return size;
  }
  return size && sizes[size] ? sizes[size] : { width, height };
};

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) {
    return "";
  }
  const dimensions = getDimensions(size, sizes);

  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
  `;
};

const propsToCss = ({ size, fillColor, fillColorRule, noStyles }) =>
  getCss(size,  fillColor, fillColorRule, noStyles);

const Image = styled.svg`
  ${propsToCss};
`;

const children = (
  <Fragment>
    <defs key="key-0">
      <linearGradient
        id="s-6b47c606b2-a"
        x1="-2631.37"
        x2="-2631.12"
        y1="354.3"
        y2="354.3"
        gradientTransform="matrix(-1 0 0 1 -2493.27 -283.92)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#595959" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#5c5c5c" />
      </linearGradient>
      <linearGradient
        id="s-6b47c606b2-d"
        x1="-2630.18"
        x2="-2629.93"
        y1="354.25"
        y2="354.25"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-e"
        x1="-2629.07"
        x2="-2628.82"
        y1="354.19"
        y2="354.19"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-f"
        x1="-2627.96"
        x2="-2627.71"
        y1="354.11"
        y2="354.11"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-g"
        x1="-2626.77"
        x2="-2626.52"
        y1="354.04"
        y2="354.04"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-h"
        x1="-2625.66"
        x2="-2625.41"
        y1="353.97"
        y2="353.97"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-i"
        x1="-2624.54"
        x2="-2624.29"
        y1="353.91"
        y2="353.91"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-j"
        x1="-2623.35"
        x2="-2623.1"
        y1="353.83"
        y2="353.83"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-k"
        x1="-2622.24"
        x2="-2621.99"
        y1="353.77"
        y2="353.77"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-l"
        x1="-2621.13"
        x2="-2620.88"
        y1="353.71"
        y2="353.71"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-m"
        x1="-2619.94"
        x2="-2619.69"
        y1="353.67"
        y2="353.67"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-n"
        x1="-2618.83"
        x2="-2618.58"
        y1="353.55"
        y2="353.55"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-o"
        x1="-2617.75"
        x2="-2617.5"
        y1="353.48"
        y2="353.48"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-p"
        x1="-2616.56"
        x2="-2616.31"
        y1="353.45"
        y2="353.45"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-q"
        x1="-2615.45"
        x2="-2615.2"
        y1="353.38"
        y2="353.38"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-r"
        x1="-2636.48"
        x2="-2620.2"
        y1="344.19"
        y2="344.19"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-s"
        x1="-2636.47"
        x2="-2620.19"
        y1="342.73"
        y2="342.73"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-t"
        x1="-2636.46"
        x2="-2620.19"
        y1="341.35"
        y2="341.35"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-u"
        x1="-2636.46"
        x2="-2620.18"
        y1="339.9"
        y2="339.9"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-v"
        x1="-2636.45"
        x2="-2620.18"
        y1="338.52"
        y2="338.52"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-w"
        x1="-2636.59"
        x2="-2620.31"
        y1="373.88"
        y2="373.88"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-x"
        x1="-2636.59"
        x2="-2620.31"
        y1="375.08"
        y2="375.08"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-y"
        x1="-2636.58"
        x2="-2620.3"
        y1="372.5"
        y2="372.5"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-z"
        x1="-2636.58"
        x2="-2620.3"
        y1="371.04"
        y2="371.04"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-A"
        x1="-2636.57"
        x2="-2620.29"
        y1="369.66"
        y2="369.66"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-B"
        x1="-2636.56"
        x2="-2620.29"
        y1="368.21"
        y2="368.21"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-C"
        x1="-2636.56"
        x2="-2620.28"
        y1="366.83"
        y2="366.83"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-D"
        x1="-2636.55"
        x2="-2620.28"
        y1="365.37"
        y2="365.37"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-E"
        x1="-2636.55"
        x2="-2620.27"
        y1="363.99"
        y2="363.99"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-F"
        x1="-2636.54"
        x2="-2620.27"
        y1="362.54"
        y2="362.54"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-G"
        x1="-2636.54"
        x2="-2620.26"
        y1="361.12"
        y2="361.12"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-H"
        x1="-2636.53"
        x2="-2620.26"
        y1="359.67"
        y2="359.67"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-I"
        x1="-2636.53"
        x2="-2620.25"
        y1="358.28"
        y2="358.28"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-J"
        x1="-2636.52"
        x2="-2620.25"
        y1="356.83"
        y2="356.83"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-K"
        x1="-2636.52"
        x2="-2620.24"
        y1="355.45"
        y2="355.45"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-L"
        x1="-2636.51"
        x2="-2620.23"
        y1="353.99"
        y2="353.99"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-M"
        x1="-2636.51"
        x2="-2620.23"
        y1="352.61"
        y2="352.61"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-N"
        x1="-2636.5"
        x2="-2620.22"
        y1="351.16"
        y2="351.16"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-O"
        x1="-2636.5"
        x2="-2620.22"
        y1="349.78"
        y2="349.78"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-P"
        x1="-2636.49"
        x2="-2620.21"
        y1="348.32"
        y2="348.32"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-Q"
        x1="-2636.49"
        x2="-2620.21"
        y1="346.94"
        y2="346.94"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-R"
        x1="-2636.48"
        x2="-2620.2"
        y1="345.49"
        y2="345.49"
        gradientTransform="matrix(-.99 0 0 1 -2480.25 -276.4)"
        xlinkHref="#s-6b47c606b2-a"
      />
      <linearGradient
        id="s-6b47c606b2-S"
        x1="120.45"
        x2="139.55"
        y1="69.36"
        y2="69.36"
        xlinkHref="#s-6b47c606b2-a"
      />
      <radialGradient
        id="s-6b47c606b2-T"
        cx="123.87"
        cy="66.1"
        r="1.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#999" />
        <stop offset="1" stopColor="#4d4d4d" />
      </radialGradient>
      <linearGradient
        id="s-6b47c606b2-U"
        x1="473.27"
        x2="473.29"
        y1="349.36"
        y2="348.85"
        gradientTransform="matrix(1.11 .01 .01 1 -401.6 -285.44)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#4d4d4d" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#4d4d4d" />
      </linearGradient>
      <linearGradient
        id="s-6b47c606b2-V"
        x1="1957.53"
        x2="1957.75"
        y1="757.06"
        y2="756.63"
        gradientTransform="rotate(-27.38 391.605 3461.088)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d45a24" />
        <stop offset=".84" stopColor="#a2272d" />
      </linearGradient>
      <linearGradient
        id="s-6b47c606b2-W"
        x1="718.05"
        x2="718.45"
        y1="994.78"
        y2="994.92"
        gradientTransform="matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f15a24" />
        <stop offset=".83" stopColor="#a6272d" />
      </linearGradient>
      <linearGradient
        id="s-6b47c606b2-b"
        x1="536.78"
        x2="536.94"
        y1="338.87"
        y2="338.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#be1e2d" />
        <stop offset="1" stopColor="#ee4036" />
      </linearGradient>
      <linearGradient
        id="s-6b47c606b2-X"
        x1="535.22"
        x2="544.27"
        y1="339.96"
        y2="339.96"
        xlinkHref="#s-6b47c606b2-b"
      />
      <linearGradient
        id="s-6b47c606b2-c"
        x1="454.99"
        x2="454.99"
        y1="388.99"
        y2="403.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#c1272d" />
        <stop offset=".53" stopColor="#c6594b" />
        <stop offset="1" stopColor="#c1272d" />
      </linearGradient>
      <linearGradient
        id="s-6b47c606b2-Y"
        x1="438.8"
        x2="471.66"
        y1="395.78"
        y2="395.78"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-Z"
        x1="460.53"
        x2="471.49"
        y1="378.78"
        y2="378.78"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-aa"
        x1="439.68"
        x2="450.65"
        y1="391.11"
        y2="391.11"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-ab"
        x1="449.78"
        x2="472.1"
        y1="385.55"
        y2="385.55"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-ac"
        x1="450.71"
        x2="472.11"
        y1="385.94"
        y2="385.94"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-ad"
        x1="-1038.21"
        x2="-1038.21"
        y1="400.17"
        y2="420.62"
        gradientTransform="matrix(-1 0 0 1 -787.99 -283.92)"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-ae"
        x1="-1046.33"
        x2="-1029.64"
        y1="409.66"
        y2="409.66"
        gradientTransform="matrix(-1 0 0 1 -787.99 -283.92)"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-af"
        x1="610.37"
        x2="620.82"
        y1="390.62"
        y2="390.62"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-ag"
        x1="616.9"
        x2="627.06"
        y1="409.22"
        y2="409.22"
        xlinkHref="#s-6b47c606b2-c"
      />
      <linearGradient
        id="s-6b47c606b2-ah"
        x1="610.22"
        x2="617.22"
        y1="400.38"
        y2="400.38"
        xlinkHref="#s-6b47c606b2-c"
      />
    </defs>
    <g id="surface">
      <g id="mainSurface">
        <path
          d="M278 171.44L1.64 151.5l110.11-64.41 138.86 8.41L278 171.44z"
          style={{
            fill: "#4d4d4d",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M265.98 163.47L24.12 145.99l90.27-53.88 130.5 8.07 21.09 63.29z"
          style={{
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M132.38 160.94l47.07-69.85"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <path
        id="surfaceBasket"
        className="basketball"
        d="M187.04 115.42l-44.8-2.57 12.72-18.29 40.9 2.62-8.82 18.24z"
      />
    </g>
    <g id="lines">
      <g id="basketballLines" className="basketball">
        <path
          d="M483.38 376c-32.79 35.26 124.5 43.76 129.89 8.3"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M187.04 115.42l-44.8-2.57 12.72-18.29 40.9 2.62-8.82 18.24z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M556.08 399.34c-3.05 4.33-11.31 7.4-22.25 7.19-12.46-.23-24.5-3.55-22.56-9.93"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-369.04 -283.92)"
        />
      </g>
    </g>
    <image
      id="high"
      width="1150"
      height="723"
      transform="translate(4.16) scale(.24)"
      xlinkHref={_8x71}
    />
    <image
      id="medium"
      width="1136"
      height="627"
      transform="matrix(.24 0 0 .24 5.12 17.04)"
      xlinkHref={_8x72}
    />
    <image
      id="small"
      width="1118"
      height="597"
      transform="matrix(.24 0 0 .24 9.92 27.84)"
      xlinkHref={_8x73}
    />
    <g id="wicket">
      <path
        d="M139.05 89.15l-18.1-1.03V49.68l18.1 1.06v38.41z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M138.83 60.86l-.85-.07v-3.37l.85.07v3.37zM138.83 82.15l-.85-.07v-3.36l.85.06v3.37z"
        style={{
          fill: "#999",
        }}
      />
      <path
        d="M137.98 52.22v36.33"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-a)",
        }}
      />
      <path
        d="M136.79 52.15V88.5"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-d)",
        }}
      />
      <path
        d="M135.68 52.1v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-e)",
        }}
      />
      <path
        d="M134.57 51.98v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-f)",
        }}
      />
      <path
        d="M133.38 51.91v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-g)",
        }}
      />
      <path
        d="M132.27 51.85v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-h)",
        }}
      />
      <path
        d="M131.15 51.78v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-i)",
        }}
      />
      <path
        d="M129.96 51.7v36.43"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-j)",
        }}
      />
      <path
        d="M128.84 51.64v36.42"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-k)",
        }}
      />
      <path
        d="M127.74 51.57v36.44"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-l)",
        }}
      />
      <path
        d="M126.55 51.57v36.35"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-m)",
        }}
      />
      <path
        d="M125.43 51.43v36.39"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-n)",
        }}
      />
      <path
        d="M124.36 51.39v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-o)",
        }}
      />
      <path
        d="M123.17 51.33v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-p)",
        }}
      />
      <path
        d="M122.06 51.26v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-q)",
        }}
      />
      <path
        d="M137.98 57.82l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-r)",
        }}
      />
      <path
        d="M137.98 56.37l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-s)",
        }}
      />
      <path
        d="M137.98 54.99l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-t)",
        }}
      />
      <path
        d="M137.98 53.54l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-u)",
        }}
      />
      <path
        d="M137.98 52.16l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-v)",
        }}
      />
      <path
        d="M137.98 87.45l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-w)",
        }}
      />
      <path
        d="M137.98 88.65l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-x)",
        }}
      />
      <path
        d="M137.98 86.07l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-y)",
        }}
      />
      <path
        d="M137.98 84.62l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-z)",
        }}
      />
      <path
        d="M137.98 83.24l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-A)",
        }}
      />
      <path
        d="M137.98 81.79l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-B)",
        }}
      />
      <path
        d="M137.98 80.41l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-C)",
        }}
      />
      <path
        d="M137.98 78.96l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-D)",
        }}
      />
      <path
        d="M137.98 77.58l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-E)",
        }}
      />
      <path
        d="M137.98 76.13l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-F)",
        }}
      />
      <path
        d="M137.98 74.71l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-G)",
        }}
      />
      <path
        d="M137.98 73.26l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-H)",
        }}
      />
      <path
        d="M137.98 71.88l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-I)",
        }}
      />
      <path
        d="M137.98 70.43l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-J)",
        }}
      />
      <path
        d="M137.98 69.05l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-K)",
        }}
      />
      <path
        d="M137.98 67.6l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-L)",
        }}
      />
      <path
        d="M137.98 66.23l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-M)",
        }}
      />
      <path
        d="M137.98 64.77l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-N)",
        }}
      />
      <path
        d="M137.98 63.4l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-O)",
        }}
      />
      <path
        d="M137.98 61.94l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-P)",
        }}
      />
      <path
        d="M137.98 60.57l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-Q)",
        }}
      />
      <path
        d="M137.98 59.11l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-6b47c606b2-R)",
        }}
      />
      <path
        d="M120.95 87.93V49.74l18.1 1.05v38.18"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-6b47c606b2-S)",
        }}
      />
      <circle
        cx="123.87"
        cy="66.1"
        r="1.36"
        style={{
          fill: "url(#s-6b47c606b2-T)",
        }}
      />
      <path
        d="M123.87 66.1l3.45.16"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          stroke: "url(#s-6b47c606b2-U)",
        }}
      />
    </g>
    <g id="basketballAcross" className="basketball">
      <path
        d="M177.02 96.5l-2.09-.13V51.52l2.09-.01V96.5z"
        style={{
          fill: "#666",
        }}
      />
      <path
        d="M177.02 96.5l1.04-.59V51.17l-1.04.34V96.5z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M178.06 51.17l-1.04.34-2.67.01 1.86-.42 1.85.07z"
        style={{
          fill: "#858589",
        }}
      />
      <path
        d="M176.75 67.84l-1.82-.15-3.22-14.24 1.83.15 3.21 14.24z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M176.75 63.2l.01 4.64-3.22-14.24h-2.02l.98-1h1.86l2.39 10.6z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M554.77 329.09c-1.4-4.76-6.46-8.29-12.49-8.29s-10.46 2.15-11.86 6.91v6.08l5.87 6.18 12.14.71 6.3-5.49v-.08z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M548.48 340.76l-12.21-.71-5.91-6.24v-6.1c1.34-4.56 5.47-7 11.94-7 6 0 11.12 3.43 12.57 8.35v6.17zm-12.13-.87l12.07.7 6.25-5.45v-6c-1.43-4.84-6.53-8.22-12.4-8.22-6.38 0-10.45 2.36-11.77 6.83v6z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M547.9 340.15l-11.39-.66-5.51-5.85V327.88c1.26-4.28 5.12-6.55 11.16-6.55 5.56 0 10.39 3.22 11.75 7.82V334.96l-.08.12zM536.74 339l11 .64 5.64-4.87v-5.5c-1.31-4.37-5.93-7.42-11.25-7.42-4 0-9.15 1.07-10.66 6.15v5.48z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M174.02 55.92l-2.47-.14v-2.33l2.47.13v2.34z"
        style={{
          fill: "#c1272d",
        }}
      />
      <path
        d="M546.59 337.94l-9.17-.51v-7.58l9.17.5zm-8.59-1.09l7.93.44v-6.36l-7.93-.43z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M542.11 338.29A3.15 3.15 0 0 0 541 338a4.5 4.5 0 0 0-1.36.08l1-.75 2.47.13z"
        style={{
          fill: "#ea371f",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M541.49 339.41l-5.79.23a.12.12 0 0 1-.15-.08.12.12 0 0 1 .08-.16l5.78-.23a.13.13 0 0 1 .16.08.13.13 0 0 1-.08.16z"
        style={{
          fill: "url(#s-6b47c606b2-V)",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M544.14 339.91a.22.22 0 0 1 0 .14c0 .07-.11.07-.17 0l-2.06-.64a.22.22 0 0 1 0-.23.1.1 0 0 1 .17 0l2.06.63a.19.19 0 0 1 0 .1z"
        style={{
          fill: "url(#s-6b47c606b2-W)",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M536.07 341.72a4.42 4.42 0 0 1-.14-.63l-.18-.12c.1.25.25.51.32.75zM536.76 341.92c.12.25.25.49.39.73a4.46 4.46 0 0 1-.41-1.16l-.15-.06c.06.16.11.33.17.49zM541.11 344c.18-.19.35-.39.51-.59 0-.36-.11-.71-.18-1.05a.49.49 0 0 1 0-.11c-.2.29-.4.57-.61.85l.21.62c-.04.06.03.16.07.28zM537.61 340.49l.24.92.58.09c0-.67.05-1.33.1-2a2.93 2.93 0 0 1 .13-1.05 7.48 7.48 0 0 0-1.62.36 3.87 3.87 0 0 1 .57 1.68zM537.23 342.61a4.91 4.91 0 0 0 .82 1.15c0-.1.07-.2.09-.3s.06-.25.09-.37c-.13-.32-.24-.65-.34-1a3.87 3.87 0 0 1-.24-.37 7.11 7.11 0 0 1-.8-.21 4.35 4.35 0 0 0 .38 1.1zM541.5 342.07a7.35 7.35 0 0 1 .24 1.17v-.06c.06-.51.1-1 .12-1.54h-.17zM539.47 340.71c0-.29-.07-.59-.11-.88a4.51 4.51 0 0 0-.16-1c0-.08-.11-.25-.2-.27s-.22.19-.26.32a4.56 4.56 0 0 0-.08.9c0 .55 0 1.15-.07 1.76h.95c-.02-.27-.04-.54-.07-.83zM539.71 341.91v.23a1.57 1.57 0 0 0 .09-.23h-.1zM542 342.94a6.18 6.18 0 0 0 .4-.64 5.29 5.29 0 0 0 .06-.8l-.36.1c-.05.45-.1.9-.1 1.34zM541.43 341.88l.1-.16h-.12s.01.11.02.16zM539.59 342.39v-.48h-.32a5.92 5.92 0 0 1 .32.48zM538 342c.11.13.21.27.32.41v-.59a3.32 3.32 0 0 1-.44-.06 2.17 2.17 0 0 0 .12.24zM538.49 342.65l.31.42c.1.12.2.25.29.38.13-.24.24-.48.36-.72l.06-.13c-.13-.23-.26-.46-.37-.69h-.57c-.02.22-.04.48-.08.74zM539.74 342.45v.19c.18.29.34.59.49.89l.42-.53c-.13-.37-.26-.74-.36-1.11H540c-.1.2-.18.38-.26.56zM542.55 341.78c.05-.12.08-.25.12-.37h-.12a1.82 1.82 0 0 1 0 .37zM540.73 342.89c.21-.29.42-.57.61-.87l-.06-.25a8.58 8.58 0 0 1-.92.11c.14.33.26.67.37 1.01zM541.37 341.39a2.84 2.84 0 0 0 .42-.09c.11-.18.22-.37.32-.57a13.74 13.74 0 0 1 .84-1.83 6.05 6.05 0 0 0-1.69-.45 2.15 2.15 0 0 1 0 .23c.12.9.02 1.82.11 2.71zM543.91 339.87c0-.3-.27-.6-.72-.85a7.66 7.66 0 0 1-.24 1.87c.62-.3.97-.67.96-1.02zM536.34 342.24c.18.33.37.66.58 1h.05v.1c.22.33.45.64.69 1l.1.12c.05-.11.1-.22.14-.33a10 10 0 0 1-.95-1.38 7.13 7.13 0 0 1-.55-1.31l-.31-.15a10.34 10.34 0 0 0 .25.95zM536 340.72l.26.17c-.12-.39-.23-.78-.32-1.17a6.63 6.63 0 0 0 .06 1zM539.68 341.55h.32c.07-.22.14-.43.2-.65.15-.55.23-1.12.4-1.67a3.9 3.9 0 0 1 .29-.82 8.45 8.45 0 0 0-1.14 0 5.17 5.17 0 0 0-.57 0 3.78 3.78 0 0 1 .4 1.6c.02.51.07.99.1 1.54zM541.17 339.34a3.49 3.49 0 0 0 0-.73c-.09-.34-.15-.05-.21.1s-.11.27-.16.41c-.16.5-.25 1-.37 1.52q-.12.45-.27.9a9 9 0 0 0 1.11-.12 20.49 20.49 0 0 1-.1-2.08zM536.67 341.08a7.61 7.61 0 0 1 0-2.13 3.4 3.4 0 0 0-.7.41c.12.55.27 1.08.44 1.62zM542.2 343.58c.15-.3.29-.61.41-.91a10.92 10.92 0 0 0 .33-1.37h-.09a5.75 5.75 0 0 1-.35.93 8.56 8.56 0 0 1-.3 1.35z"
        style={{
          fill: "none",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M168.75 57.84z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M542.85 342.35c-.05.15-.09.3-.14.44a8 8 0 0 0 .89-1.87 3 3 0 0 1-.4.25 11.83 11.83 0 0 1-.35 1.18zM543.07 339a5.42 5.42 0 0 0-.44 1 11.34 11.34 0 0 1-.57 1.16l-.06.11a6.35 6.35 0 0 0 .81-.28 8.09 8.09 0 0 0 .26-1.99zM539.28 344.67c.09-.12.19-.23.29-.35l-.46-.63-.22.41q.18.29.39.57zM541.93 343.21c0 .25-.07.5-.12.76l.19-.19c.12-.38.22-.75.3-1.13-.12.19-.24.35-.37.56zM541.16 344.12c0 .13.09.26.13.39l.35-.36v-.13-.44c-.15.18-.32.36-.48.54zM536.71 340.08a6 6 0 0 0 .06 1 6.35 6.35 0 0 0 .92.26c-.14-.53-.26-1.07-.39-1.59 0-.14-.16-.81-.36-.94l-.16.07a4.74 4.74 0 0 0 0 .69c-.06.19-.07.35-.07.51zM539.75 343v1.13l.39-.48c-.14-.23-.26-.44-.39-.65zM539 343.58l-.33-.44c-.08-.1-.15-.2-.23-.29 0 .1 0 .2-.05.3a5.7 5.7 0 0 0 .41.82c.09-.13.2-.26.2-.39zM535.85 339.49a.69.69 0 0 0 0 1.1 8.09 8.09 0 0 1 0-1.1zM539.6 342.74c-.13.27-.27.54-.41.8l.42.56q.01-.67-.01-1.36zM540.7 344.4l.31-.32-.12-.37-.18-.54-.39.51.1.2c.1.17.19.34.28.52zM538.31 342.66l-.16-.2.13.36zM538.73 344.13l-.12-.21c-.09-.17-.18-.35-.26-.53a3.24 3.24 0 0 1-.16.53l.41.43c.04-.08.09-.15.13-.22zM538 343.89c-.16-.18-.31-.37-.45-.56.14.2.28.4.44.59z"
        style={{
          fill: "none",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M536.67 341.08h.1a6 6 0 0 1-.06-1v-.47a4.74 4.74 0 0 1 0-.69h-.08a7.61 7.61 0 0 0 .04 2.16zM538.43 341.5h.16c0-.61 0-1.21.07-1.76a4.56 4.56 0 0 1 .08-.9c0-.13.1-.36.26-.32s.17.19.2.27a4.51 4.51 0 0 1 .16 1c0 .29.08.59.11.88s0 .56.07.84h.14c0-.51-.08-1-.14-1.55a3.78 3.78 0 0 0-.4-1.6l-.48.05a2.93 2.93 0 0 0-.13 1.05c-.05.71-.06 1.37-.1 2.04zM536 340.72a6.63 6.63 0 0 1-.06-1c.09.39.2.78.32 1.17l.16.09c-.17-.54-.32-1.07-.44-1.62l-.15.13a8.09 8.09 0 0 0 0 1.1zM536.77 338.53a.13.13 0 0 0-.11.05l.11-.05zM537.3 339.79c.13.52.25 1.06.39 1.59h.16l-.24-.92a3.87 3.87 0 0 0-.57-1.68h-.1c.2.22.33.87.36 1.01z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M542.71 342.79c0-.14.09-.29.14-.44a11.83 11.83 0 0 0 .34-1.16l-.26.13a10.92 10.92 0 0 1-.33 1.37c-.12.3-.26.61-.41.91a8.56 8.56 0 0 0 .3-1.31 5.75 5.75 0 0 0 .35-.93l-.18.07c0 .12-.07.25-.12.37a1.82 1.82 0 0 0 0-.33l-.13.05a5.29 5.29 0 0 1-.06.8 6.18 6.18 0 0 1-.4.64c0-.44.09-.89.1-1.34h-.15c0 .52-.06 1-.12 1.54v.06a7.35 7.35 0 0 0-.24-1.17l.24-.39-.21.05-.1.16v-.13h-.13l.06.25c-.19.3-.4.58-.61.87-.11-.34-.23-.68-.37-1h-.07c.1.37.23.74.36 1.11l-.42.53c-.15-.3-.31-.6-.49-.89v-.19c.08-.18.16-.36.23-.55h-.16a1.57 1.57 0 0 1-.09.23v-.23h-.15v.48a5.92 5.92 0 0 0-.35-.48h-.1c.11.23.24.46.37.69l-.06.13c-.12.24-.23.48-.36.72-.09-.13-.19-.26-.29-.38l-.31-.42c0-.26.06-.52.08-.78h-.18v.59c-.11-.14-.21-.28-.32-.41a2.17 2.17 0 0 1-.07-.24H537.74a3.87 3.87 0 0 0 .24.37c.1.33.21.66.34 1 0 .12-.05.24-.09.37l-.09.3a4.91 4.91 0 0 1-.82-1.15 4.35 4.35 0 0 1-.38-1.08h-.11a4.46 4.46 0 0 0 .41 1.16c-.14-.24-.27-.48-.39-.73s-.11-.33-.17-.49l-.18-.08a7.13 7.13 0 0 0 .55 1.31 10 10 0 0 0 .95 1.38c0 .11-.09.22-.14.33l-.1-.12c-.24-.32-.47-.63-.69-1v-.1h-.05c-.21-.31-.4-.64-.58-1a10.34 10.34 0 0 1-.24-1l-.17-.11a4.42 4.42 0 0 0 .14.63c-.12-.24-.22-.5-.32-.75l-.15-.13a9.8 9.8 0 0 0 1.39 2.71c.1.36.22.72.35 1.07a3.85 3.85 0 0 0 0 .59 11.22 11.22 0 0 1-.09 1.53v.35c-.08.4-.3 1.56.26 1.15a.6.6 0 0 0 .31.24.45.45 0 0 0 .48-.15c.13.22.3.44.54.43a.46.46 0 0 0 .34-.25l.09-.13a.61.61 0 0 0 .86.15 1.13 1.13 0 0 0 .27-.3.71.71 0 0 0 .16.18c.33.24.49-.14.55-.4v-.1l.17.32c0 .06.11 0 .13 0a6.51 6.51 0 0 0 .08-1.71 7.58 7.58 0 0 1 .08-.82v-.05c.05-.27.12-.54.19-.8a.75.75 0 0 0 .07-.12 9.33 9.33 0 0 0 .52-1.11V343.51a10.73 10.73 0 0 0 1.31-2.65 1.66 1.66 0 0 1-.21.16 8 8 0 0 1-.84 1.77zm-1.31-.58a.49.49 0 0 0 0 .11c.07.34.14.69.18 1.05-.16.2-.33.4-.51.59 0-.1-.08-.2-.11-.3l-.21-.62c.25-.26.45-.54.65-.83zm-3.88 2.9l.21.48-.19.21a6 6 0 0 1-.09-.61zm-.08 0a2.45 2.45 0 0 1 0-.27 1.34 1.34 0 0 0 .07.18zm.35.62l.21.44-.3.37c-.06-.2-.1-.39-.14-.59a2.39 2.39 0 0 0 .23-.23zm1.55-.41l-.2-.18zm-.09-.3l.06-.08c.12.15.25.3.38.44l-.07.07c-.12-.16-.25-.3-.37-.45zm.2.58l-.41.4-.3-.38c.11-.13.22-.25.32-.38zm-.34-.73l-.41-.41.11-.2a6.3 6.3 0 0 0 .37.53zm-.1.11l-.08-.07-.31-.31c.13.11.26.24.38.4zm-.1.12l-.3.35c-.1-.12-.2-.24-.29-.37l.21-.34zm-.39.45l-.43.5c-.07-.14-.14-.28-.2-.42a5.2 5.2 0 0 0 .35-.44zm-.43.8l.23.43-.11.13-.27.36c-.07-.18-.13-.36-.19-.55.12-.13.25-.26.34-.38zm.16 0l-.06-.12.47-.52c.1.12.2.24.29.37l-.53.57zm.79-.16c.13.16.25.32.37.49l-.22.27-.35.43-.34-.59c.17-.21.35-.4.5-.6zm.09-.09l.26-.25.16-.16.37.37-.42.52zm1.47-.52l.34-.38c.07.14.14.27.2.41s-.18.27-.28.4zm.13.6l-.1.12-.32-.39.16-.19c.09.15.18.28.26.46zm-.25-.78l-.24-.37.42-.41.19.38c-.13.13-.25.27-.37.4zm-.11.14c-.07.07-.13.15-.19.22l-.31-.36.26-.25c.08.12.16.26.24.39zm-.26.31a.52.52 0 0 0-.1.11l-.06-.06c-.08-.13-.16-.24-.25-.36l.07-.07zm-.06.35l.31.39-.1.12-.37.43-.06-.09-.25-.35zm.22.05l-.13-.15.09-.11.33.4-.09.11zm.37.25c.08.12.17.23.24.35l-.06.17-.27-.41zm.07-.09l.09-.11c.05.11.11.21.17.32v.1a3.46 3.46 0 0 0-.26-.31zm.22-.28l.28-.37v.05l-.18.56zm.12-1.05l.22-.24c0 .13.09.25.13.38l-.16.24zm-.1-.2l-.18-.36.29-.3c0 .13.09.26.13.4zm-.24-1.71l.18.54.12.37-.31.32c-.09-.18-.18-.35-.28-.52l-.1-.2zm-.44.7c.12.21.22.42.33.63l-.44.42-.31-.44a.76.76 0 0 0-.08-.11c.16-.19.31-.39.46-.58.01.03.03.05.04.08zm-.52-.88c.13.22.27.43.39.65l-.39.48c.01-.38.01-.75 0-1.12zm0 1.56c.11.16.22.32.32.48l-.16.15-.12.11c-.13-.15-.25-.3-.37-.46l.28-.35zm-.54-1c.14-.26.28-.53.41-.8v1.38l-.42-.56zm-.08.15l.46.63c-.1.12-.2.23-.29.35q-.21-.29-.39-.57zm-.65-.84c.08.09.15.19.23.29l.33.44c-.06.13-.13.26-.2.39a5.7 5.7 0 0 1-.41-.82c0-.11.01-.16.03-.31zm-.31-.39l.16.2v.16zm.2.93c.08.18.17.36.26.53l.12.21c0 .07-.09.14-.13.22l-.41-.43a3.24 3.24 0 0 0 .14-.54zm-.2.66l.38.42-.37-.42zm-.59-.72c.14.19.29.38.45.56-.19-.17-.33-.37-.47-.57zm.51.91l.36.39-.21.32-.31-.39a3.18 3.18 0 0 0 .14-.33zm-.23.44l.3.38c-.1.14-.21.28-.32.41l-.2-.48a3.46 3.46 0 0 0 .2-.32zm-.67-.89l.56.75c-.05.11-.11.21-.16.32-.17-.36-.3-.72-.42-1.08zm.27 2.28a5.66 5.66 0 0 0 .15.59l-.23.3c-.01-.3.04-.6.06-.9zm-.19 1.48a1.35 1.35 0 0 0 .09.33c-.18-.12-.14-.16-.11-.34zm.27.39a1.84 1.84 0 0 1-.14-.51v-.3l.29-.3a9 9 0 0 0 .22.55c-.09.13-.17.26-.25.4s-.11.13-.14.15zm.1.12c.06-.09.1-.2.15-.28l.15-.24.21.41.1.2c-.16.12-.34.16-.63-.1zm.55-.31l-.16-.34.31-.41.08-.1.34.62c-.1.11-.19.22-.28.34a1.92 1.92 0 0 1-.13.17c-.08-.1-.13-.2-.18-.29zm.64.59c-.3 0-.31 0-.4-.17l.06-.07.35-.44a5.14 5.14 0 0 0 .35.55c-.09.13-.09.13-.38.12zm.44-.26c-.09-.14-.16-.29-.22-.39s-.07-.11-.1-.16c.19-.24.39-.48.59-.71l.08.11.23.33c-.14.17-.28.35-.41.54a2.61 2.61 0 0 0-.19.27zm1.08 0a.63.63 0 0 1-.8.29.65.65 0 0 1-.18-.16c.14-.21.26-.44.41-.64l.16-.2.26.4c.06.08.11.19.17.29zm.08-.14a6.19 6.19 0 0 1-.42-.66l.47-.58c.1.15.2.3.29.46-.08.21-.17.42-.27.64a.61.61 0 0 0-.09.19zm.66-.15c0 .11 0 .22-.07.33-.24.11-.4.1-.49 0a5.41 5.41 0 0 0 .33-.8l.24.43s-.03.03-.03.05zm0-.3l-.21-.36.12-.14c.06.1.11.21.16.31a1.49 1.49 0 0 1-.05.2zm0-.42l-.13-.24v-.08l.11.21a.37.37 0 0 0 .08.12zm0-.56l.06-.17a2.11 2.11 0 0 0 0 .25.3.3 0 0 1-.01-.07zm.23 1.47a3 3 0 0 0-.16-.31.78.78 0 0 0 0-.16 2.55 2.55 0 0 1 .13.39zm0-.27a2.6 2.6 0 0 0-.15-.42.49.49 0 0 1 0-.12l.16.3c.09.09.09.17.08.25zm0-1.45v.91l-.14-.33c0-.27 0-.53.07-.79l.07.14s.1.06.1.08zm0-.32a.61.61 0 0 0-.05-.12l.09-.36v.07c.13.14.11.28.09.46zm0-1l-.09-.26.2-.22c.1.2.07.36.03.53zm.11.34v-.11zm.07-1.18l-.35.36c0-.13-.09-.26-.13-.39.16-.18.33-.36.48-.54v.44c0 .15.15.12.14.17zm.23.07v.06l-.05.09v-.11l.1-.1zm-.06-.25c.05-.26.09-.51.12-.76s.25-.37.37-.56c-.08.38-.18.75-.3 1.13z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M540.16 340.9c-.06.22-.13.43-.2.65h.15q.15-.45.27-.9c.12-.51.21-1 .37-1.52 0-.14.1-.28.16-.41s.12-.44.21-.1a3.49 3.49 0 0 1 0 .73 20.49 20.49 0 0 0 .05 2.08h.15c-.09-.89 0-1.81-.09-2.71a2.15 2.15 0 0 0 0-.23h-.41a3.9 3.9 0 0 0-.29.82c-.14.47-.22 1.04-.37 1.59zM541.79 341.3l.21-.05.06-.11a11.34 11.34 0 0 0 .57-1.16 5.42 5.42 0 0 1 .44-1 8.09 8.09 0 0 1-.26 2l.14-.08a7.66 7.66 0 0 0 .24-1.87l-.24-.12a13.74 13.74 0 0 0-.84 1.83c-.11.19-.21.38-.32.56zM543.19 338.91a.13.13 0 0 0 .1-.14.15.15 0 0 0-.15-.15.16.16 0 0 0-.15.16.43.43 0 0 1 0 .05v.07l.24.12zM539 338.29a.09.09 0 0 0 0-.05.18.18 0 0 0-.18-.17.19.19 0 0 0-.17.18.14.14 0 0 0 0 .07.44.44 0 0 0-.08.11l.52-.05a.47.47 0 0 0-.09-.09zM541.41 338.3a.19.19 0 0 0 0-.13.19.19 0 0 0-.21-.1.17.17 0 0 0-.12.11.31.31 0 0 0 0 .1l-.08.1.44.05a.57.57 0 0 0-.03-.13zM536.71 338.81v.14h.08v-.07a.11.11 0 0 1 .12 0h.1l-.13-.12a.14.14 0 0 0-.14-.16l-.11.05a.15.15 0 0 0 .08.16zM536 339.36v-.05a.11.11 0 0 0 0-.08.13.13 0 0 0-.15-.13.14.14 0 0 0-.14.14.16.16 0 0 0 .14.14.37.37 0 0 1 0 .11z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M536.82 338.85v.07l.16-.07a.11.11 0 0 0-.16 0z"
        style={{
          fill: "url(#s-6b47c606b2-b)",
        }}
        transform="translate(-369.04 -283.92)"
      />
      <path
        d="M539.7 338a9 9 0 0 0-2.93.52.14.14 0 0 1 .14.16l.13.12a7.48 7.48 0 0 1 1.62-.36.31.31 0 0 1 .08-.11.14.14 0 0 1 0-.06.15.15 0 0 1 .16-.16.15.15 0 0 1 .16.15.31.31 0 0 1 .11.09 5.17 5.17 0 0 1 .57 0 8.45 8.45 0 0 1 1.14 0l.08-.1a.22.22 0 0 1 0-.08.14.14 0 0 1 .1-.1.16.16 0 0 1 .19.08.29.29 0 0 1 0 .13.34.34 0 0 1 0 .12 6.05 6.05 0 0 1 1.69.45v-.07a.43.43 0 0 0 0-.05.16.16 0 0 1 .15-.16.15.15 0 0 1 .15.15.13.13 0 0 1-.1.14v.14c.45.25.71.55.72.85s-.34.72-1 1l-.14.08a6.35 6.35 0 0 1-.81.28l-.21.05a2.84 2.84 0 0 1-.42.09h-.15a9 9 0 0 1-1.11.12h-1.68l-.58-.09h-.16a6.35 6.35 0 0 1-.92-.26h-.1l-.23-.1-.16-.09-.26-.17-.16-.13a.69.69 0 0 1 0-1.1.37.37 0 0 0 0-.11.16.16 0 0 1-.14-.14.14.14 0 0 1 .14-.14.13.13 0 0 1 .15.13.11.11 0 0 1 0 .08v.05a3.4 3.4 0 0 1 .7-.41v-.14a.15.15 0 0 1-.05-.23c-.9.38-1.46.9-1.44 1.49a1.11 1.11 0 0 0 .38.77l.15.13.18.12.17.11.31.15.18.08.15.06h.11a7.11 7.11 0 0 0 .8.21H537.86a3.32 3.32 0 0 0 .44.06h1.97a8.58 8.58 0 0 0 .92-.11h.25l.21-.05h.32l.36-.1.13-.05h.12l.18-.07h.09l.26-.13a3 3 0 0 0 .4-.25 1.66 1.66 0 0 0 .21-.16 1.19 1.19 0 0 0 .46-.9c.07-1.22-1.94-1.98-4.48-1.98z"
        style={{
          fill: "url(#s-6b47c606b2-X)",
        }}
        transform="translate(-369.04 -283.92)"
      />
    </g>
    <g id="unihockey">
      <g id="unihockeyLeft">
        <path
          d="M102.25 129.4l-45.16-2.84 43.05-25.96 40.12 2.67-38.01 26.13z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M450.71 403.72L438.8 403v-1.09l20.86-12.45a3.13 3.13 0 0 1 2-.41l9.5 1.3v1.09l-9.22-.58a3.13 3.13 0 0 0-1.81.44l-16.69 10.12 7.27 1.24z"
          style={{
            fill: "url(#s-6b47c606b2-c)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M450.57 402.62l-11.77-.74 21-12.51a3.08 3.08 0 0 1 1.78-.43l10.11.63-.44.58a.37.37 0 0 1-.33.15l-9.14-.57a3.11 3.11 0 0 0-1.79.43l-18.61 11.1 10.39.66-.93.63a.36.36 0 0 1-.27.07z"
          style={{
            fill: "url(#s-6b47c606b2-Y)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M470.49 370.22a25.54 25.54 0 0 1-5.79-.59v-.1a26.28 26.28 0 0 0 6.25.57v.11zM470.44 369.64a24.28 24.28 0 0 1-5.49-.56v-.11a24.22 24.22 0 0 0 6 .55v.11zM470.54 371.38a28.3 28.3 0 0 1-6.06-.6v-.11a28.7 28.7 0 0 0 6.47.6v.11zM470.52 370.8a26.67 26.67 0 0 1-5.93-.6v-.1a27.79 27.79 0 0 0 6.36.59v.11zM470.46 372.43a29.2 29.2 0 0 1-6.13-.58v-.11a30 30 0 0 0 6.62.58v.11zM470.55 371.85a29.18 29.18 0 0 1-6.16-.61v-.11a29.5 29.5 0 0 0 6.56.61v.11zM470.51 373.59A32.27 32.27 0 0 1 464 373v-.11a32.05 32.05 0 0 0 6.91.6v.11zM470.47 373a31 31 0 0 1-6.32-.58v-.11a31.13 31.13 0 0 0 6.8.58v.11zM470.56 374.76a33.93 33.93 0 0 1-6.74-.63v-.11a34.18 34.18 0 0 0 7.13.62v.11zM470.61 374.17a33.1 33.1 0 0 1-6.67-.67v-.11a33.43 33.43 0 0 0 7 .67v.11zM470.4 375.92a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM470.57 375.34a35.08 35.08 0 0 1-6.86-.64v-.11a35.86 35.86 0 0 0 7.24.64v.11zM470.46 377a38.53 38.53 0 0 1-7.08-.6v-.11a39.13 39.13 0 0 0 7.57.6v.11zM470.42 376.39a37.13 37.13 0 0 1-6.93-.59v-.11a38 38 0 0 0 7.46.59v.11zM470.65 378.13a41.38 41.38 0 0 1-7.47-.73v-.11a40 40 0 0 0 7.82.71v.11zM470.48 377.55a38.92 38.92 0 0 1-7.21-.61v-.1a40.23 40.23 0 0 0 7.68.6v.11zM470.62 378.71a42.29 42.29 0 0 1-7.56-.7v-.11a40.72 40.72 0 0 0 7.89.7v.11zM470.54 379.88a44.2 44.2 0 0 1-7.72-.65v-.1a46.18 46.18 0 0 0 8.14.64v.1zM470.62 379.3a42.41 42.41 0 0 1-7.68-.72v-.1a42.54 42.54 0 0 0 8 .7v.11zM470.38 381a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM470.34 380.46a44.83 44.83 0 0 1-7.62-.58v-.11a46.08 46.08 0 0 0 8.23.58v.11zM470.42 382.2a49.89 49.89 0 0 1-8.07-.6v-.11a49.41 49.41 0 0 0 8.6.6v.11zM470.4 381.62a48.43 48.43 0 0 1-7.94-.6v-.11a48.13 48.13 0 0 0 8.49.6v.11zM470.44 383.25a51.2 51.2 0 0 1-8.29-.62v-.11a50.64 50.64 0 0 0 8.8.62v.11zM470.34 382.67a49.19 49.19 0 0 1-8.08-.58V382a50.84 50.84 0 0 0 8.7.58v.11zM470.34 384.42a52.89 52.89 0 0 1-8.39-.59v-.1a55.55 55.55 0 0 0 9 .58v.1zM470.57 383.83a52.74 52.74 0 0 1-8.52-.71v-.11a50.87 50.87 0 0 0 8.9.71v.11zM470.29 385.58a56.78 56.78 0 0 1-8.6-.59v-.11a58.45 58.45 0 0 0 9.27.59v.11zM470.27 385a55.22 55.22 0 0 1-8.46-.58v-.11a56.83 56.83 0 0 0 9.14.58v.11zM470.34 386.74a60.29 60.29 0 0 1-8.88-.6v-.11a60 60 0 0 0 9.49.6v.11zM470.31 386.16a57.24 57.24 0 0 1-8.74-.6v-.1a59.8 59.8 0 0 0 9.38.59v.11zM470.38 387.79a63.23 63.23 0 0 1-9.12-.61v-.11a62.68 62.68 0 0 0 9.7.61v.11zM470.36 387.21a60.31 60.31 0 0 1-9-.61v-.11a62.55 62.55 0 0 0 9.59.61v.11zM470.28 389a66.15 66.15 0 0 1-9.26-.58v-.11a67.63 67.63 0 0 0 9.93.58v.1zM470.27 388.38a63.23 63.23 0 0 1-9.13-.59v-.1a65.35 65.35 0 0 0 9.82.57v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M92.71 105.41l-.11-.02 3.93-20.77.1.02-3.92 20.77zM93.6 105.41l-.11-.02 3.75-20.84.1.02-3.74 20.84zM100.61 105.96l-.11-.01.16-21.24h.1l-.15 21.25z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M458.41 379.12h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 140.611 423.625)"
        />
        <path
          d="M99.11 105.8H99l.44-21.1h.1l-.43 21.1zM96.46 105.65l-.11-.01 2.28-21.09.11.01-2.28 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M457.35 379.04h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.3 135.603 427.285)"
        />
        <path
          d="M455.44 378.9h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 120.917 445.746)"
        />
        <path
          d="M454.67 378.87h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 115.395 451.752)"
        />
        <path
          d="M97.53 105.65l-.11-.01 1.45-21.08h.11l-1.45 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M461.14 389.38l-.61-.12 3.88-19.74a1.67 1.67 0 0 1 1.74-1.35l5.34.31v.62l-5.34-.31a1.06 1.06 0 0 0-1.09.85z"
          style={{
            fill: "url(#s-6b47c606b2-Z)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M446.23 374.76h24.01v.08h-24.01z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.96 -238.807 899.127)"
        />
        <path
          d="M442.84 374.73h24.47v.08h-24.47z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.58 -248.735 907.762)"
        />
        <path
          d="M78.18 96.92l-.04-.06 20.53-12.33.04.06-20.53 12.33zM77.49 96.8l-.04-.06 20.27-12.17.04.06L77.49 96.8zM76.5 96.92l-.03-.06 20.6-12.33.04.06L76.5 96.92z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M466.72 367.3h.08v3.27h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86.86 132.296 421.892)"
        />
        <path
          d="M465.82 368.07h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.7 111.274 448.587)"
        />
        <path
          d="M97.45 86.28l-2.55-.63.02-.07 2.55.62-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M464.56 369.05h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.96 73.38 496.946)"
        />
        <path
          d="M463.94 369.42h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.46 70.824 499.839)"
        />
        <path
          d="M447.98 378.25h.08v4.01h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86 111.588 435.507)"
        />
        <path
          d="M448.75 377.93h.08v3.47h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-84.68 108.44 440.202)"
        />
        <path
          d="M449.65 377.51h.08v3.21h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.67 100.899 450.666)"
        />
        <path
          d="M450.48 377.07h.08v3.11h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.3 97.484 453.535)"
        />
        <path
          d="M90.75 90.33l-3.05-.43.02-.08 3.04.43-.01.08zM91.64 89.79l-3.01-.44.01-.07 3.01.43-.01.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M451.45 376.5h.08v3.09h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.34 98.826 454.67)"
        />
        <path
          d="M452.26 376.09h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 92.452 463.468)"
        />
        <path
          d="M453.07 375.56h.08v3.04h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="matrix(.18 -.98 .98 .18 -366.57 473.18)"
        />
        <path
          d="M453.9 375.13h.08v2.91h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 94.112 462.492)"
        />
        <path
          d="M87.05 92.56l-2.88-.58.02-.07 2.87.57-.01.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M455.52 374.1h.08v3.03h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.59 103.601 451.275)"
        />
        <path
          d="M462.78 369.7h.08v3.2h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="matrix(.17 -.98 .98 .17 -351.95 479.04)"
        />
        <path
          d="M95.55 87.42l-2.44-.71.02-.07 2.44.7-.02.08zM94.45 88.09l-2.76-.54.01-.08 2.77.54-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M461.33 370.73h.08v2.77h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.21 105.305 453.163)"
        />
        <path
          d="M460.64 371.16h.08v2.8h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.13 101.291 457.939)"
        />
        <path
          d="M459.97 371.57h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-77.77 99.457 459.803)"
        />
        <path
          d="M457.59 372.91h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.64 102.846 453.738)"
        />
        <path
          d="M89.22 91.25l-2.83-.57.01-.08 2.84.57-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M456.25 373.8h.08v2.76h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-75.78 89.38 470.335)"
        />
        <path
          d="M438.46 394.47h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.763 924.279)"
        />
        <path
          d="M438.49 393.89h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.74 923.698)"
        />
        <path
          d="M438.65 393.28h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.588 923.074)"
        />
        <path
          d="M438.83 392.73h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.402 922.538)"
        />
        <path
          d="M438.86 392.15h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.38 921.957)"
        />
        <path
          d="M439.01 391.54h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.21 921.338)"
        />
        <path
          d="M439.08 391.04h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -250.152 920.845)"
        />
        <path
          d="M439.29 390.51h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.93 920.319)"
        />
        <path
          d="M439.32 389.93h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.907 919.738)"
        />
        <path
          d="M439.48 389.31h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.755 919.114)"
        />
        <path
          d="M439.66 388.77h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.569 918.578)"
        />
        <path
          d="M439.69 388.19h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.54 917.979)"
        />
        <path
          d="M439.85 387.57h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.376 917.378)"
        />
        <path
          d="M439.91 387.07h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.314 916.866)"
        />
        <path
          d="M440.01 386.51h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.218 916.305)"
        />
        <path
          d="M440.03 385.93h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.196 915.724)"
        />
        <path
          d="M440.19 385.31h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -249.044 915.1)"
        />
        <path
          d="M440.37 384.77h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.858 914.564)"
        />
        <path
          d="M440.4 384.18h24.27v.11H440.4z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.835 913.983)"
        />
        <path
          d="M440.56 383.57h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.665 913.364)"
        />
        <path
          d="M440.62 383.07h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.608 912.871)"
        />
        <path
          d="M440.8 382.4h24.27v.11H440.8z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.441 912.193)"
        />
        <path
          d="M440.95 381.78h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.271 911.574)"
        />
        <path
          d="M441.14 381.24h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.085 911.038)"
        />
        <path
          d="M441.16 380.66h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -248.062 910.457)"
        />
        <path
          d="M441.32 380.04h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.91 909.833)"
        />
        <path
          d="M441.38 379.54h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.853 909.34)"
        />
        <path
          d="M441.48 378.98h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.758 908.779)"
        />
        <path
          d="M441.51 378.39h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.717 908.202)"
        />
        <path
          d="M441.66 377.78h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.565 907.579)"
        />
        <path
          d="M441.85 377.23h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.379 907.043)"
        />
        <path
          d="M441.88 376.65h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.351 906.443)"
        />
        <path
          d="M442.03 376.04h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.204 905.838)"
        />
        <path
          d="M442.09 375.54h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -247.142 905.326)"
        />
        <path
          d="M432.58 390.85h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 85.394 473.788)"
        />
        <path
          d="M433.75 390.13h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 86.56 473.063)"
        />
        <path
          d="M433.16 390.51h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 85.97 473.446)"
        />
        <path
          d="M434.26 389.85h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 87.076 472.783)"
        />
        <path
          d="M435.43 389.12h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 88.242 472.057)"
        />
        <path
          d="M434.84 389.51h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 87.653 472.44)"
        />
        <path
          d="M435.94 388.85h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 90.251 472.93)"
        />
        <path
          d="M437.11 388.12h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 89.93 471.057)"
        />
        <path
          d="M436.52 388.51h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 89.33 471.44)"
        />
        <path
          d="M437.63 387.84h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 90.44 470.771)"
        />
        <path
          d="M438.8 387.12h20.58v.11H438.8z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 91.612 470.051)"
        />
        <path
          d="M438.2 387.5h20.58v.11H438.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 91.011 470.435)"
        />
        <path
          d="M439.31 386.9h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 92.128 469.832)"
        />
        <path
          d="M440.48 386.17h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 93.294 469.107)"
        />
        <path
          d="M439.89 386.56h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 92.7 469.496)"
        />
        <path
          d="M440.99 385.89h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 93.81 468.827)"
        />
        <path
          d="M442.16 385.17h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 94.976 468.101)"
        />
        <path
          d="M441.57 385.55h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 94.381 468.49)"
        />
        <path
          d="M442.68 384.9h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 95.498 467.837)"
        />
        <path
          d="M443.85 384.18h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 96.665 467.112)"
        />
        <path
          d="M443.25 384.56h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 96.07 467.5)"
        />
        <path
          d="M444.36 383.9h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 97.18 466.831)"
        />
        <path
          d="M445.53 383.17h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 98.346 466.106)"
        />
        <path
          d="M444.94 383.56h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 97.752 466.495)"
        />
        <path
          d="M446.04 382.9h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 98.857 465.832)"
        />
        <path
          d="M447.21 382.17h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 100.023 465.107)"
        />
        <path
          d="M446.62 382.56h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 99.429 465.495)"
        />
        <path
          d="M447.73 381.89h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 100.539 464.826)"
        />
        <path
          d="M448.89 381.17h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 101.711 464.106)"
        />
        <path
          d="M448.3 381.56h20.58v.11H448.3z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 101.11 464.49)"
        />
        <path
          d="M449.41 380.95h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 102.221 463.882)"
        />
        <path
          d="M450.58 380.23h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 103.393 463.162)"
        />
        <path
          d="M449.99 380.61h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 102.804 463.545)"
        />
        <path
          d="M451.09 379.94h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 103.909 462.881)"
        />
        <path
          d="M451.67 379.61h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 104.486 462.539)"
        />
        <path
          d="M449.8 382.52a26.14 26.14 0 0 1-5.79-.58v-.11a26.26 26.26 0 0 0 6.25.58v.11zM449.75 381.94a23.72 23.72 0 0 1-5.49-.56v-.11a24.73 24.73 0 0 0 6 .56v.11zM449.85 383.68a27.68 27.68 0 0 1-6.06-.6v-.11a28.14 28.14 0 0 0 6.47.6v.11zM449.83 383.1a27.29 27.29 0 0 1-5.93-.59v-.11a27.19 27.19 0 0 0 6.36.59v.11zM449.77 384.73a28.55 28.55 0 0 1-6.13-.58v-.1a29.43 29.43 0 0 0 6.62.57v.11zM449.86 384.15a28.53 28.53 0 0 1-6.16-.61v-.1a29.52 29.52 0 0 0 6.56.6v.11zM449.82 385.9a31.6 31.6 0 0 1-6.47-.61v-.11a32 32 0 0 0 6.91.61v.11zM449.77 385.32a30.22 30.22 0 0 1-6.31-.59v-.1a31.76 31.76 0 0 0 6.8.58v.1zM449.86 387.06a33.9 33.9 0 0 1-6.73-.63v-.1a34.12 34.12 0 0 0 7.13.62v.11zM449.92 386.48a33.12 33.12 0 0 1-6.67-.68v-.1a33.43 33.43 0 0 0 7 .67v.11zM449.71 388.22a35.9 35.9 0 0 1-6.8-.58v-.11a35.41 35.41 0 0 0 7.35.58v.11zM449.88 387.64A35.89 35.89 0 0 1 443 387v-.11a35.89 35.89 0 0 0 7.24.63v.11zM449.78 389.27a37.71 37.71 0 0 1-7.09-.6v-.1a38.38 38.38 0 0 0 7.57.59v.11zM449.73 388.69a36.3 36.3 0 0 1-6.93-.59v-.1a37.28 37.28 0 0 0 7.46.58v.11zM450 390.44a40.37 40.37 0 0 1-7.47-.74v-.1a40.88 40.88 0 0 0 7.77.73v.11zM449.79 389.86a39.8 39.8 0 0 1-7.21-.61v-.11a39.5 39.5 0 0 0 7.68.6v.11zM449.93 391a41.5 41.5 0 0 1-7.56-.71v-.11a41.55 41.55 0 0 0 7.89.71v.11zM449.85 392.18a44.24 44.24 0 0 1-7.72-.64v-.11a45.14 45.14 0 0 0 8.13.64v.11zM449.93 391.6a43.3 43.3 0 0 1-7.68-.71v-.11a43.42 43.42 0 0 0 8 .71v.11zM449.69 393.35a46.78 46.78 0 0 1-7.8-.6v-.1a47.77 47.77 0 0 0 8.37.58v.11zM449.65 392.76a44.83 44.83 0 0 1-7.62-.58v-.11a44.29 44.29 0 0 0 8.23.58v.11zM449.73 394.51a49.85 49.85 0 0 1-8.07-.61v-.11a50.37 50.37 0 0 0 8.6.61v.11zM449.71 393.93a48.22 48.22 0 0 1-7.93-.6v-.11a49.1 49.1 0 0 0 8.49.6v.1zM449.74 395.56a52.31 52.31 0 0 1-8.28-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM449.65 395a50.4 50.4 0 0 1-8.08-.58v-.11a51.8 51.8 0 0 0 8.7.58v.1zM449.65 396.72a53 53 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM449.89 396.14a52.77 52.77 0 0 1-8.53-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM449.6 397.89a56.78 56.78 0 0 1-8.6-.59v-.11a57.34 57.34 0 0 0 9.27.58v.11zM449.58 397.3a55 55 0 0 1-8.45-.58v-.11a54.62 54.62 0 0 0 9.14.58v.11zM449.64 399.05a58.86 58.86 0 0 1-8.87-.61v-.1a61.19 61.19 0 0 0 9.49.6v.11zM449.62 398.47a58.64 58.64 0 0 1-8.74-.6v-.11a59.74 59.74 0 0 0 9.38.6v.1zM449.69 400.1a62 62 0 0 1-9.12-.62v-.11a64 64 0 0 0 9.7.62v.11zM449.67 399.52a61.68 61.68 0 0 1-9-.61v-.11a62.33 62.33 0 0 0 9.58.61v.1zM449.59 401.26a64.66 64.66 0 0 1-9.26-.58v-.11a66.36 66.36 0 0 0 9.93.58v.11zM449.58 400.68a63.34 63.34 0 0 1-9.13-.58v-.1a65.24 65.24 0 0 0 9.82.58v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M72.02 117.72l-.11-.02 3.93-20.78.1.02-3.92 20.78zM72.91 117.72l-.11-.02 3.75-20.84.1.01-3.74 20.85zM79.92 118.26h-.11l.16-21.24h.1l-.15 21.24z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M437.72 391.42h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 119.93 435.91)"
        />
        <path
          d="M78.42 118.11l-.11-.01.44-21.09h.1l-.43 21.1zM75.77 117.95l-.1-.01 2.27-21.08.11.01-2.28 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M436.66 391.35h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.08 115.845 440.25)"
        />
        <path
          d="M434.75 391.21h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 100.228 458.05)"
        />
        <path
          d="M433.98 391.17h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 94.71 464.056)"
        />
        <path
          d="M76.84 117.95h-.11l1.45-21.09.11.01-1.45 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M440.3 401.71l-.62-.12 3.88-19.74a1.71 1.71 0 0 1 1.75-1.35l5.34.31v.63l-5.34-.32a1.08 1.08 0 0 0-1.1.85z"
          style={{
            fill: "url(#s-6b47c606b2-aa)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M450.78 403.57l-1-.41.07-22.07a1.55 1.55 0 0 1 .75-1.33l20.15-12.17a.45.45 0 0 1 .32 0l.75.23a.4.4 0 0 1 .28.39l-.93 23.24-.93-.06v-21.71a.39.39 0 0 0-.59-.33l-18.12 10.94a1.56 1.56 0 0 0-.75 1.33z"
          style={{
            fill: "url(#s-6b47c606b2-ab)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M451 403.43l-.29.29.07-22.1a1.56 1.56 0 0 1 .75-1.33l20-12.07a.39.39 0 0 1 .59.33v20.63a3.12 3.12 0 0 1-.92 2.21v-21.18a.39.39 0 0 0-.59-.34l-18.12 10.94a1.56 1.56 0 0 0-.75 1.34v19.53a2.47 2.47 0 0 1-.74 1.75z"
          style={{
            fill: "url(#s-6b47c606b2-ac)",
          }}
          transform="translate(-369.04 -283.92)"
        />
      </g>
      <g id="unihockeyRight">
        <path
          d="M259.36 144.14l-50.83-3.29-4.08-32.28 44.26 2.64 10.65 32.93z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M247.4 136.08l10.94.62v-1l-6.53-19.45-9.71.21v1l8.49.48 5.46 17.04-8.65.1v1z"
          style={{
            fill: "url(#s-6b47c606b2-ad)",
          }}
        />
        <path
          d="M247.41 135.08l10.93.62-6.53-19.45-10.16-.47.52.68 9.03.51 5.86 18.06-9.85-.56.2.61z"
          style={{
            fill: "url(#s-6b47c606b2-ae)",
          }}
        />
        <path
          d="M620.38 401.17c-1 0-2.07-.05-3.28-.14v-.1a36.15 36.15 0 0 0 7-.07v.1a34.21 34.21 0 0 1-3.72.21zM620.33 400.64c-1 0-2 0-3.19-.13v-.1a34 34 0 0 0 6.73-.07v.09a31.81 31.81 0 0 1-3.54.21zM620.37 402.22c-1.06 0-2.17-.05-3.36-.13V402a39.71 39.71 0 0 0 7.27-.08v.1a36.35 36.35 0 0 1-3.91.2zM620.37 401.69c-1 0-2.13 0-3.32-.13v-.1a37.48 37.48 0 0 0 7.14-.08v.1a35.16 35.16 0 0 1-3.82.21zM620.54 403.19c-1.11 0-2.28-.05-3.62-.15v-.1a40.68 40.68 0 0 0 7.43-.05v.1c-1.35.13-2.52.2-3.81.2zM620.37 402.64c-1.09 0-2.21 0-3.4-.13v-.1a39.82 39.82 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM620.58 404.24c-1.18 0-2.41-.05-3.75-.15V404a43.32 43.32 0 0 0 7.75-.05v.1c-1.32.12-2.58.19-4 .19zM620.69 403.72c-1.18 0-2.42-.05-3.81-.15v-.1a42.75 42.75 0 0 0 7.62 0v.1c-1.26.08-2.5.15-3.81.15zM620.58 405.29c-1.24 0-2.52-.05-3.84-.14v-.1a47.14 47.14 0 0 0 8-.06v.1c-1.31.13-2.74.2-4.16.2zM620.11 404.74c-1.1 0-2.2 0-3.32-.12v-.1a45 45 0 0 0 7.87-.11v.1a44.63 44.63 0 0 1-4.55.23zM621 406.37c-1.33 0-2.71-.06-4.31-.17v-.1a49.21 49.21 0 0 0 8.24 0v.1c-1.4.12-2.66.17-3.93.17zM620.58 405.82c-1.27 0-2.57-.05-3.88-.15v-.1a48.74 48.74 0 0 0 8.13-.05v.1c-1.33.13-2.76.2-4.25.2zM621 407.32c-1.4 0-2.85-.05-4.43-.17v-.1a53.46 53.46 0 0 0 8.49 0v.1c-1.35.12-2.68.17-4.06.17zM621 406.8c-1.35 0-2.76-.06-4.37-.18v-.09a53 53 0 0 0 8.36 0v.1c-1.37.11-2.66.17-3.99.17zM620.05 408.33c-1.11 0-2.31 0-3.57-.12v-.1a56.25 56.25 0 0 0 8.73-.11v.1c-1.42.12-3.16.23-5.16.23zM621 407.85c-1.43 0-2.91-.06-4.5-.17v-.1a54.92 54.92 0 0 0 8.61 0v.1c-1.32.11-2.68.17-4.11.17zM620.33 408.87c-1.32 0-2.61-.05-3.9-.14v-.1a57 57 0 0 0 8.85-.07v.1c-1.69.14-3.34.21-4.95.21zM621.09 410c-1.55 0-3.16-.06-4.75-.17v-.1a62.88 62.88 0 0 0 9.11 0v.1c-1.34.07-2.82.17-4.36.17zM620.39 409.4c-1.36 0-2.7 0-4-.14v-.1a58.67 58.67 0 0 0 9-.07v.1c-1.69.14-3.39.21-5 .21zM621.57 411c-1.66 0-3.38-.06-5.32-.2v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.37.13-2.69.13-4.06.13zM621.51 410.52c-1.61 0-3.27-.07-5.22-.21v-.1a62.09 62.09 0 0 0 9.22.07v.1c-1.38.09-2.67.14-4 .14zM621.64 412.1c-1.74 0-3.54-.07-5.48-.21v-.1a67.85 67.85 0 0 0 9.64.07v.1c-1.37.09-2.74.14-4.16.14zM621.6 411.57c-1.69 0-3.46-.07-5.4-.2v-.1a66 66 0 0 0 9.51.06v.1c-1.36.1-2.71.14-4.11.14zM621.88 413.05c-1.66 0-3.38-.06-5.32-.2v-.1a65.56 65.56 0 0 0 9.37.07v.1c-1.36.08-2.69.13-4.05.13zM622 412.54c-1.81 0-3.73-.07-5.86-.22v-.1a71.38 71.38 0 0 0 9.74.1v.1c-1.26.08-2.55.12-3.88.12zM622.42 414.14c-1.73 0-3.59-.08-5.81-.23v-.1a66.17 66.17 0 0 0 9.46.11v.1c-1.21.08-2.4.12-3.65.12zM621.16 413.54c-1.51 0-3-.06-4.6-.17v-.1a64.63 64.63 0 0 0 9.44 0v.1c-1.74.11-3.3.17-4.84.17zM622.44 415.2c-1.68 0-3.36-.08-5.66-.24v-.1a66.34 66.34 0 0 0 9.49.13v.09c-1.42.08-2.62.12-3.83.12zM622.37 414.67c-1.65 0-3.29-.07-5.59-.23v-.1a66.32 66.32 0 0 0 9.39.12v.1c-1.42.07-2.61.11-3.8.11zM621.91 416.28c-1.56 0-3.21-.06-5.27-.2V416a69.85 69.85 0 0 0 9.78.06v.1c-1.61.07-3.02.12-4.51.12zM622.49 415.73c-1.73 0-3.49-.08-5.79-.24v-.1a66.86 66.86 0 0 0 9.64.12v.1c-1.34.08-2.61.12-3.85.12zM622 417.24c-1.62 0-3.34-.06-5.43-.21v-.1a73.33 73.33 0 0 0 10 .07v.1c-1.57.08-3.03.14-4.57.14zM622 416.71c-1.59 0-3.27-.06-5.34-.21v-.1a70 70 0 0 0 9.89.07v.1c-1.66.08-3.09.14-4.55.14zM622.55 418.32c-1.92 0-3.86-.08-6.08-.24V418a77.15 77.15 0 0 0 10.27.12v.1c-1.44.06-2.81.1-4.19.1zM622.43 417.79c-1.87 0-3.74-.08-5.92-.23v-.1a76.83 76.83 0 0 0 10.15.1v.1c-1.48.08-2.86.13-4.23.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M256.87 135.32l-2.3-19.23.1-.01 2.3 19.23-.1.01z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M623.95 399.82h.1v19.56h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-5.8 -2363.198 3909.92)"
        />
        <path
          d="M248.38 134.88h-.1l.08-19.19h.1l-.08 19.19zM249.05 134.86h-.1l.08-19.08h.1l-.08 19.08zM249.78 134.99h-.1l.14-19.21h.1l-.14 19.21z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M621.41 399.77h.1v19.19h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.57 -9923.484 13734.63)"
        />
        <path
          d="M250.65 115.78h.1v19.28h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M622.12 399.8h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-2.39 -6367.138 9113.664)"
        />
        <path
          d="M623.08 399.82h.1v19.48h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.12 -3508.328 5397.319)"
        />
        <path
          d="M620.53 399.7h.1V419h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.81 -19648.517 26370.133)"
        />
        <path
          d="M614 382.56c-.71 0-1.44 0-2.26-.07v-.1a28.49 28.49 0 0 0 6.2-.22v.1a26.61 26.61 0 0 1-3.94.29zM614 382c-.68 0-1.4 0-2.24-.07v-.1a26.22 26.22 0 0 0 5.95-.21v.1a25.48 25.48 0 0 1-3.71.28zM613.88 383.6c-.72 0-1.46 0-2.25-.07v-.1a31.33 31.33 0 0 0 6.43-.22v.1a29 29 0 0 1-4.18.29zM613.9 383.08c-.71 0-1.45 0-2.24-.07v-.1a30.18 30.18 0 0 0 6.31-.22v.1a27.87 27.87 0 0 1-4.07.29zM614.06 384.55c-.77 0-1.59 0-2.49-.08v-.09a32.73 32.73 0 0 0 6.57-.2v.1a31.63 31.63 0 0 1-4.08.27zM613.86 384c-.73 0-1.47 0-2.26-.07v-.1a32.22 32.22 0 0 0 6.52-.22v.09a29.75 29.75 0 0 1-4.26.3zM614 385.59c-.8 0-1.63 0-2.51-.07v-.1a34.79 34.79 0 0 0 6.85-.21v.1a33.08 33.08 0 0 1-4.34.28zM614.13 385.08c-.81 0-1.66 0-2.59-.08v-.1a34.35 34.35 0 0 0 6.75-.19v.1a31.57 31.57 0 0 1-4.16.27zM613.94 386.63c-.81 0-1.64 0-2.49-.07v-.1a37.21 37.21 0 0 0 7.08-.21v.1a35.57 35.57 0 0 1-4.59.28zM613.62 386.1c-.71 0-1.42 0-2.14-.06v-.1a35.41 35.41 0 0 0 7-.27v.1a36.57 36.57 0 0 1-4.86.33zM614.34 387.7c-.92 0-1.88 0-3-.1v-.1a39.65 39.65 0 0 0 7.3-.16v.1a37.77 37.77 0 0 1-4.3.26zM613.92 387.16c-.82 0-1.66 0-2.5-.08V387a39.34 39.34 0 0 0 7.2-.21v.09a35.09 35.09 0 0 1-4.7.28zM614.29 388.64c-.94 0-1.92 0-3-.09v-.1a42.9 42.9 0 0 0 7.51-.17v.1a40.24 40.24 0 0 1-4.51.26zM614.33 388.12c-.93 0-1.9 0-3-.1v-.1a39.87 39.87 0 0 0 7.4-.16v.1a38.93 38.93 0 0 1-4.4.26zM613.5 389.65c-.71 0-1.46 0-2.23-.06v-.1a44.56 44.56 0 0 0 7.72-.28v.1a47.36 47.36 0 0 1-5.49.34zM614.28 389.16c-1 0-1.94 0-3-.09V389a44.17 44.17 0 0 0 7.62-.17v.1a41.44 41.44 0 0 1-4.62.23zM613.69 390.18c-.83 0-1.64 0-2.45-.07V390a45.24 45.24 0 0 0 7.84-.25v.1a48 48 0 0 1-5.39.33zM614.2 391.24c-1 0-2 0-3-.09v-.1a48.56 48.56 0 0 0 8.08-.18v.1a44.62 44.62 0 0 1-5.08.27zM613.7 390.7c-.84 0-1.67 0-2.49-.07v-.1a45.36 45.36 0 0 0 7.95-.25v.1a46.39 46.39 0 0 1-5.46.32zM614.69 392.3c-1.12 0-2.29 0-3.57-.1v-.1a51.53 51.53 0 0 0 8.31-.13v.1a46.78 46.78 0 0 1-4.74.23zM614.7 391.79c-1.1 0-2.25 0-3.55-.12v-.09a49.8 49.8 0 0 0 8.17-.13v.1a45.31 45.31 0 0 1-4.62.24zM614.68 393.35c-1.16 0-2.36 0-3.63-.11v-.1a54.32 54.32 0 0 0 8.53-.13v.1c-1.58.16-3.2.24-4.9.24zM614.68 392.83c-1.14 0-2.32 0-3.6-.11v-.1a52.92 52.92 0 0 0 8.42-.13v.1a48 48 0 0 1-4.82.24zM614.68 394.29c-1.18 0-2.41 0-3.68-.11v-.1a55.8 55.8 0 0 0 8.74-.13v.1c-1.62.16-3.3.24-5.06.24zM615 393.78c-1.23 0-2.54 0-3.94-.12v-.1a55.27 55.27 0 0 0 8.63-.1v.1a46.63 46.63 0 0 1-4.69.22zM615.14 395.35c-1.32 0-2.73 0-4.2-.13v-.1a57.87 57.87 0 0 0 8.93-.08v.1c-1.42.14-3.01.21-4.73.21zM614 394.79q-1.53 0-3-.09v-.1a57.38 57.38 0 0 0 8.84-.2v.1c-2.03.19-3.95.29-5.84.29zM615.15 396.4c-1.33 0-2.72 0-4.28-.13v-.1a63.36 63.36 0 0 0 9.19-.08v.1c-1.67.14-3.24.21-4.91.21zM615.14 395.88c-1.31 0-2.68-.05-4.24-.13v-.1a61.55 61.55 0 0 0 9.06-.08v.1c-1.66.14-3.19.21-4.82.21zM615.16 397.44c-1.38 0-2.8 0-4.35-.13v-.1a66.44 66.44 0 0 0 9.41-.08v.1c-1.67.14-3.32.21-5.06.21zM615.15 396.92c-1.35 0-2.76-.05-4.31-.13v-.1a64.88 64.88 0 0 0 9.3-.08v.1c-1.67.14-3.28.21-4.99.21zM615.16 398.38c-1.42 0-2.88 0-4.4-.13v-.1a67.93 67.93 0 0 0 9.62-.08v.1c-1.68.14-3.38.21-5.22.21zM615.16 397.86c-1.4 0-2.84 0-4.37-.13v-.1a67.87 67.87 0 0 0 9.51-.08v.1c-1.68.14-3.37.21-5.14.21zM615.67 399.44c-1.56 0-3.22-.05-5-.14v-.1a74.28 74.28 0 0 0 9.85 0v.1c-1.45.08-3.09.14-4.85.14zM615.6 398.92c-1.52 0-3.14-.05-4.88-.15v-.1a69.34 69.34 0 0 0 9.73 0v.1c-1.45.09-3.11.15-4.85.15z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M618.63 381.26h.1v19.11h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-7.17 -1831.667 3194.093)"
        />
        <path
          d="M617.91 381.16h.1v19.31h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-6.26 -2163.077 3622.99)"
        />
        <path
          d="M242.91 116.27l-.02-19.11h.1l.02 19.11h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M612.63 381.18h.1v18.95h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.13 -124688.65 162909.251)"
        />
        <path
          d="M613.39 381.18h.1v18.94h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.31 -52054.748 68451.802)"
        />
        <path
          d="M247.02 116.19l-.81-18.94.1-.01.81 18.95h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M614.19 381.18h.1v18.99h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.75 -21260.137 28440.802)"
        />
        <path
          d="M616.29 381.17h.1v19.1h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-3.2 -4650.503 6854.684)"
        />
        <path
          d="M617.14 381.17h.1v19.24h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.75 -2990.45 4697.594)"
        />
        <path
          d="M614.94 381.08h.1v19.09h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.41 -11106.974 15243.31)"
        />
        <path
          d="M620.26 400.53l-2.2-18.14c-.07-.78-.94-.92-1.66-.9l-6-.2v-.57l6 .2c1.88-.06 2.18 1 2.22 1.41l2.19 18.13z"
          style={{
            fill: "url(#s-6b47c606b2-af)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M621 401.86l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M621.43 403.14l-2.2-18.14a1.31 1.31 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M621.93 404.75l-2.2-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.2v-.09l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M622.38 405.89l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M622.84 407.23l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M623.31 408.58l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2V389l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M623.81 410.2l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M624.3 411.61l-2.2-18.13a1.29 1.29 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M624.77 413.05l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.43 1.43 0 0 1 1.34 1.28l2.19 18.09z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M625.25 414.48l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M625.76 416.23l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M626.23 417.56L624 399.42a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M626.49 419.16L624.3 401a1.08 1.08 0 0 0-1-1l-6.38-.2v-.57l6.38.2a1.65 1.65 0 0 1 1.57 1.49l2.19 18.12z"
          style={{
            fill: "url(#s-6b47c606b2-ag)",
          }}
          transform="translate(-369.04 -283.92)"
        />
        <path
          d="M614.89 380.54h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.86 -473.183 1422.49)"
        />
        <path
          d="M616.05 380.65h.1v19.37h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.47 -492.394 1449.296)"
        />
        <path
          d="M250.98 115.79l-5.7-18.56.09-.03 5.71 18.56-.1.03zM252.28 115.79l-6.09-18.62.09-.03 6.09 18.62-.09.03zM253.34 115.79l-6.31-18.52.1-.03 6.3 18.52-.09.03z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M620.34 380.79h.1v19.52h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-18.69 -426.658 1369.93)"
        />
        <path
          d="M616.65 420.19a.56.56 0 0 1-.57-.57v-20.11l-4.72-14.73v16.46a.57.57 0 0 1-.57.57.56.56 0 0 1-.57-.57v-20.11a.57.57 0 0 1 1.11-.18l5.83 18.21a.53.53 0 0 1 .06.24v20.22a.57.57 0 0 1-.57.57z"
          style={{
            fill: "url(#s-6b47c606b2-ah)",
          }}
          transform="translate(-369.04 -283.92)"
        />
      </g>
    </g>
  </Fragment>
);

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: "&&& path, &&& use, &&& g",
  size: null,
};

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    }),
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name];
    if (typeof prop !== "object") {
      return;
    }
    for (let key in prop) {
      if (
        !prop[key] ||
        typeof prop[key].width !== "number" ||
        typeof prop[key].height !== "number"
      ) {
        return new Error(
          "Invalid prop `" +
            name +
            "` supplied to `" +
            componentName +
            "`. Validation failed."
        );
      }
    }
  },
};

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: "8x7",
});
